import { h } from "harmaja"
import * as L from "lonna"
import { DEFAULT_NOTE_COLOR, NOTE_COLORS, TRANSPARENT } from "../../../../common/src/colors"
import { Board, Color, Item, isColoredItem, isTextItem } from "../../../../common/src/domain"
import { SubmenuProps } from "./ContextMenuView"

// Text colors: strong hues that read on light and dark fills, plus black/white
const TEXT_COLORS: Color[] = ["#00263a", "#ffffff", "#f62a5c", "#e07000", "#1d9a4b", "#2266cc", "#8a3ffc"]

export function colorsSubMenu({ board, focusedItems, dispatch }: SubmenuProps) {
    const coloredItems = L.view(focusedItems, (items) => items.items.filter(isColoredItem))
    const textItems = L.view(focusedItems, (items) => items.items.filter(isTextItem))
    const anyColored = L.view(coloredItems, (items) => items.length > 0)
    // Custom (non-palette) colors currently in use on the board, so they can be reused
    const customColors = L.view(board, customColorsInUse)

    return L.view(anyColored, customColors, (anyColored, customColors) => {
        return !anyColored
            ? []
            : [
                  <div className="colors icon-group">
                      {NOTE_COLORS.map((color) => {
                          return (
                              <span
                                  className={`icon color ${color.name}`}
                                  style={{ background: color.color === TRANSPARENT ? undefined : color.color }}
                                  onClick={() => setColor(color.color)}
                              />
                          )
                      })}
                      {customColors.map((color) => (
                          <span
                              className="icon color custom"
                              title={color}
                              style={{ background: color }}
                              onClick={() => setColor(color)}
                          />
                      ))}
                      <span className={"icon color new-color"}>
                          <input
                              type="color"
                              onInput={(e) => setColor(e.target.value)}
                              value={itemColorOrDefault(focusedItems.get().items)}
                          />
                      </span>
                      {textItems.get().length === 0 ? null : (
                          <div className="text-colors">
                              <span className="hint" title="Text color">
                                  A
                              </span>
                              {TEXT_COLORS.map((color) => (
                                  <span
                                      className="icon text-color"
                                      style={{ color }}
                                      title={`Text color ${color}`}
                                      onClick={() => setTextColor(color)}
                                  >
                                      A
                                  </span>
                              ))}
                              <span
                                  className="icon text-color auto"
                                  title="Automatic (contrast with fill)"
                                  onClick={() => setTextColor(null)}
                              >
                                  A
                              </span>
                              <span className="icon text-color custom" title="Custom text color">
                                  <input type="color" onInput={(e) => setTextColor(e.target.value)} />
                                  <span>A</span>
                              </span>
                          </div>
                      )}
                  </div>,
              ]
    })

    function setTextColor(textColor: Color | null) {
        const b = board.get()
        const updated = textItems.get().map((item) => ({ id: item.id, textColor }))
        dispatch({ action: "item.update", boardId: b.id, items: updated })
    }

    function setColor(color: Color) {
        const b = board.get()
        if (coloredItems.get().some((i) => i.type === "drawing")) localStorage.penColor = color // next pen stroke
        const updated = coloredItems.get().map((item) => ({ id: item.id, color }))
        dispatch({ action: "item.update", boardId: b.id, items: updated })
    }
}

function itemColorOrDefault(items: Item[]) {
    const firstNoteWithColor = items.find(isColoredItem)
    if (!firstNoteWithColor) return DEFAULT_NOTE_COLOR
    return firstNoteWithColor.color
}

const PALETTE = new Set(NOTE_COLORS.map((c) => c.color.toLowerCase()))
const MAX_CUSTOM_COLORS = 8
export function customColorsInUse(board: Board): Color[] {
    const seen = new Set<string>()
    for (const item of Object.values(board.items)) {
        if (isColoredItem(item) && item.color && !PALETTE.has(item.color.toLowerCase())) seen.add(item.color)
    }
    // ponytail: last N by insertion order; no per-user "recent" history, the board itself is the history
    return [...seen].slice(-MAX_CUSTOM_COLORS)
}
